import * as z from 'zod'
import { DriverRegistrationRequest } from '~/shared/api'
import { Option, OptionEnum } from '~/shared/config/constants'
import {
  AggregatorOccupationCodeEnum,
  TaxSystemEnum,
} from '~/shared/config/enums'
import { enumOptionSchema, innRequiredSchema } from '~/shared/lib/schemas'

export const baseSchema = DriverRegistrationRequest.schema
  .pick({
    drivingLicenseIssuingCountry: true,
    drivingLicenseNumber: true,
    drivingLicenseIssueDate: true,
    drivingExperienceStartDate: true,
    drivingLicenseExpirationDate: true,
    drivingLicensePhotos: true,
    aggregatorOccupationOption: true,
  })
  .merge(
    z.object({
      isIndividualEntrepreneur: z.boolean(),
    }),
  )

const individualEntrepreneurSchema = z.object({
  isIndividualEntrepreneur: z.literal(true),
  inn: innRequiredSchema,
  taxSystem: enumOptionSchema(TaxSystemEnum),
  email: z.string().email('Неверный формат email'),
})

const regularDriverSchema = z.object({
  isIndividualEntrepreneur: z.literal(false),
})

export const formSchema = baseSchema.and(
  z.discriminatedUnion('isIndividualEntrepreneur', [
    individualEntrepreneurSchema,
    regularDriverSchema,
  ]),
)

export type SchemaType = z.infer<typeof formSchema>

export type FormValues = Omit<
  SchemaType,
  'aggregatorOccupationOption' | 'taxSystem'
> & {
  aggregatorOccupationOption:
    | (Option & { code: AggregatorOccupationCodeEnum })
    | UniqueId
  taxSystem: OptionEnum<TaxSystemEnum> | TaxSystemEnum
  inn?: string
  email?: string
}
